import type { ZustandStore } from '../store.type';
import type { NamedSet } from 'zustand/middleware';

type HeaderState = {
	header: {
		headerName: string;
		isHeaderVisible: boolean;
		showCloseButtonInTeamOverviewPageHeader: boolean;
		isHeaderMenuOnMobileViewOpened: boolean;
		headerButtons: (() => React.JSX.Element)[];
		activeHeaderTab: string;
	};
};

type HeaderActions = {
	setHeaderName: (headerName: HeaderState['header']['headerName']) => void;
	setHeaderButtons: (headerButtons: HeaderState['header']['headerButtons']) => void;
	openHeaderMenuOnMobileView: (
		isHeaderMenuOnMobileViewOpened: HeaderState['header']['isHeaderMenuOnMobileViewOpened'],
	) => void;
	setActiveHeaderTab: (activeTab: HeaderState['header']['activeHeaderTab']) => void;
};

export type HeaderSlice = HeaderState & HeaderActions;

const headerInitialState: HeaderState = {
	header: {
		headerName: '',
		isHeaderVisible: true,
		showCloseButtonInTeamOverviewPageHeader: false,
		isHeaderMenuOnMobileViewOpened: false,
		headerButtons: [],
		activeHeaderTab: '',
	},
};

export function headerSlice(set: NamedSet<ZustandStore>): HeaderSlice {
	return {
		...headerInitialState,
		setHeaderName(headerName: HeaderState['header']['headerName']): void {
			set(
				(state: HeaderState) => {
					state.header.headerName = headerName;
					return state;
				},
				false,
				`[setHeaderName]-${headerName}`,
			);
		},
		setHeaderButtons(headerButtons: HeaderState['header']['headerButtons']): void {
			set(
				(state: HeaderState) => {
					state.header.headerButtons = headerButtons;
					return state;
				},
				false,
				'[setHeaderButtons]',
			);
		},
		openHeaderMenuOnMobileView(
			isHeaderMenuOnMobileViewOpened: HeaderState['header']['isHeaderMenuOnMobileViewOpened'],
		): void {
			set(
				(state: HeaderState) => {
					state.header.isHeaderMenuOnMobileViewOpened = isHeaderMenuOnMobileViewOpened;
					return state;
				},
				false,
				`[openHeaderMenuOnMobileView]-${isHeaderMenuOnMobileViewOpened}`,
			);
		},
		setActiveHeaderTab(activeTab: HeaderState['header']['activeHeaderTab']): void {
			set(
				(state: HeaderState) => {
					state.header.activeHeaderTab = activeTab;
					return state;
				},
				false,
				`[setActiveHeaderTab]-${activeTab}`,
			);
		},
	};
}
